<template>
    <div  class="mx-10 ma-5">
        <v-card class="pa-5">
            <div>
                 <!-- Page Title -->
                <PageTitle :title="'GRN Details'" class="pb-5"></PageTitle>
                <GrnDetails></GrnDetails>

            </div>
        </v-card>

    </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle";
import GrnDetails from "@/components/GoodsReturn/GoodsReturnDetails";


export default ({

    name:'goodsReturnDetails',
    components:{PageTitle,GrnDetails},
   
    
})
</script>
